import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {environment} from 'src/environments/environment';
import {map} from 'rxjs/operators';
import {Router} from '@angular/router';
import {BusDataService} from 'src/app/paginas/expedientesRepse/busDataService';
import {RepseService} from '../repse.service';
import {NotificacionesService} from '../notificaciones.service';
import {Store} from "@ngrx/store";
import {AppState} from "../../@store/app.reducers";
import {CatExpediente, Menu, Modulo, Usuario} from "../../@store/models/usuario.model";
import {cargarUsuario, obtenerUsuarioSuccessAcc, resetDatosUsuarioAcc} from "../../@store/actions/usuario.actions";
import {Empresa} from "../../@store/models/empresa.model";
import {borrarEmpresa, cargarEmpresa} from "../../@store/actions/empresa.actions";
import {v4 as uuidv4} from 'uuid';

const url = environment.wsUrl + 'xccm/auth/';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  currentUser$: any;

  gpoAdmin = environment.idGPOAdministrador;
  gpoProveedor = environment.idGPOProveedor;

  constructor(private http: HttpClient,
              private bus: BusDataService,
              private repse: RepseService,
              private router: Router,
              private store: Store<AppState>,
              private notif: NotificacionesService
  ) {
    this.currentUser$ = this.bus.getOrCreateSubject('currentUser', undefined);

    this.currentUser$.get.subscribe((value) => {
      //console.log('AuthService - Valor del subject:', value);
    });
  }

  expedientePeriodo: number = environment.expedientePeriodo;

  iniciarSesion(info): Observable<any> {
    let headers = new HttpHeaders({"Content-Type": "application/json"});
    return this.http.post(environment.wsUrl + 'login', JSON.stringify(info), {headers: headers}).pipe(
      map((resp: any) => {
        if (resp.data ? !resp.data.changePassword : false) {
          if (resp.data ? resp.exito : false) {
            const sessionId = uuidv4();
            sessionStorage.setItem('sessionId', sessionId);
            // this.router.navigate(['/inicio']);
            this.router.navigate(['/subsidiarias']);
          }
        }
        return resp;
      }));
  }

  obtenerDatosUsuario(): Observable<any> {

    const lsc = localStorage.getItem('IES-AC-TK');
    const be = 'Bearer ' + lsc;
    let headers = new HttpHeaders({"Token": lsc, "Authorization": be});
    let menuUser = [

      {
        "idMenu": 3,
        "titulo": "Expedientes",
        "ruta": "/expedientes",
        "icono": "create_new_folder",
        "mostrarInicio": true,
        "descripcion": "Creación de expedientes"
      }
    ];

    let dataUserFake = {
      "data": {
        "idUser": 97,
        "apellidoMaterno": "Fotos",
        "apellidoPaterno": "Fotos",
        "bloqueado": false,
        "email": "susana.arellano@ies-systems.com",
        "fechaCreacion": "2020-12-18 19:25:30",
        "loginName": "pFotos",
        "nombre": "Prueba fotos",
        "group": [
          53,
          60,
          135
        ],
        "catExpedientes": [
          {
            "descripcionTipo": "repse-dev",
            "idTipo": this.expedientePeriodo,
            "idAcl": 50,
            "nombreAcl": "OCC_LECTURA",
            "n_permiso": 6,
            "c_nombre": "PROPIETARIO"
          }
        ],
        "menu": [
          // {
          //   "idMenu": 1,
          //   "titulo": "Inicio",
          //   "ruta": "/inicio",
          //   "icono": "home",
          //   "mostrarInicio": false,
          //   "descripcion": "Pantalla de inicio"
          // },
          // {
          //   "idMenu": 2,
          //   "titulo": "Administrador",
          //   "ruta": "/administrador",
          //   "icono": "security",
          //   "mostrarInicio": true,
          //   "descripcion": "Gestión de roles, permisos, usuarios"
          // },
          {
            "idMenu": 3,
            "titulo": "Expedientes",
            "ruta": "/expedientes",
            "icono": "create_new_folder",
            "mostrarInicio": true,
            "descripcion": "Creación de expedientes"
          },///
          // {
          //   "idMenu": 4,
          //   "titulo": "Documentos por proveedor",
          //   "ruta": "/documentos-proveedor",
          //   "icono": "description",
          //   "mostrarInicio": false,
          //   "descripcion": "Lista y controla documentos según cada proveedor."
          // },

          // {
          //   "idMenu": 5,
          //   "titulo": "Incumplimiento de documentos",
          //   "ruta": "/incumplimiento-documentos",
          //   "icono": "priority_high",
          //   "mostrarInicio": false,
          //   "descripcion": "Registra y supervisa documentos pendientes o incumplidos."
          // },
          // {
          //   "idMenu": 6,
          //   "titulo": "Personal subcontratado",
          //   "ruta": "/personal-subcontratado",
          //   "icono": "people",
          //   "mostrarInicio": false,
          //   "descripcion": "Información y gestión del personal subcontratado."
          // },
          // {
          //   "idMenu": 7,
          //   "titulo": "Proporción completado",
          //   "ruta": "/proporcion-completado",
          //   "icono": "timeline",
          //   "mostrarInicio": false,
          //   "descripcion": "Monitorea el progreso en la finalización de documentos."
          // },
          // {
          //   "idMenu": 8,
          //   "titulo": "Pago a contratistas",
          //   "ruta": "/pago-contratistas",
          //   "icono": "attach_money",
          //   "mostrarInicio": false,
          //   "descripcion": "Consulta y gestiona los pagos recientes realizados a los contratistas."
          // }
          // {
          //   "idMenu": 9,
          //   "titulo": "Ubicación de contratistas",
          //   "ruta": "/ubicacion-contratistas",
          //   "icono": "place",
          //   "mostrarInicio": false,
          //   "descripcion": "Visualiza las ubicaciones actuales de los contratistas en un mapa interactivo."
          // }
        ],
        "modulo": [
          {
            "idModulo": 1,
            "modulo": "/inicio",
            "ruta": "/inicio",
            "titulo": "Inicio",
            "idMenu": 1
          },
          {
            "idModulo": 2,
            "modulo": "/administrador",
            "ruta": "/administrador",
            "titulo": "Administrador dashboard",
            "idMenu": 2
          },
          {
            "idModulo": 3,
            "modulo": "/administrador",
            "ruta": "/administrador/permisos",
            "titulo": "Administrador - Conjunto de permisos",
            "idMenu": 2
          },
          {
            "idModulo": 4,
            "modulo": "/administrador",
            "ruta": "/administrador/grupos",
            "titulo": "Administrador – Grupos",
            "idMenu": 2
          },
          {
            "idModulo": 5,
            "modulo": "/administrador",
            "ruta": "/administrador/tipos",
            "titulo": "Administrador - Tipos Documentales",
            "idMenu": 2
          },
          {
            "idModulo": 6,
            "modulo": "/administrador",
            "ruta": "/administrador/usuarios",
            "titulo": "Administrador – Usuarios",
            "idMenu": 2
          },
          {
            "idModulo": 7,
            "modulo": "/administrador",
            "ruta": "/administrador/seguridad",
            "titulo": "Administrador – Seguridad",
            "idMenu": 2
          },
          {
            "idModulo": 8,
            "modulo": "/administrador",
            "ruta": "/administrador/tiempodocumentos",
            "titulo": "Administrador - Tiempo de Vida de Documentos",
            "idMenu": 2
          },
          {
            "idModulo": 9,
            "modulo": "/administrador",
            "ruta": "/administrador/expedientes",
            "titulo": "Administrador – Expedientes",
            "idMenu": 2
          },
          {
            "idModulo": 10,
            "modulo": "/expedientes",
            "ruta": "/expedientes",
            "titulo": "Expedientes",
            "idMenu": 3
          },
          {
            "idModulo": 11,
            "modulo": "/expedientes",
            "ruta": "/expedientes/carga",
            "titulo": "Nuevo expediente",
            "idMenu": 3
          },
          {
            "idModulo": 12,
            "modulo": "/expedientes",
            "ruta": "/expedientes/visor-documentos",
            "titulo": "Nuevo expediente",
            "idMenu": 3
          },
          {
            "idModulo": 13,
            "modulo": "/expedientes",
            "ruta": "/expedientes/empresa",
            "titulo": "Nuevo expediente",
            "idMenu": 3
          },
          {
            "idModulo": 14,
            "modulo": "/administrador",
            "ruta": "/administrador/reportes",
            "titulo": "Reportes",
            "idMenu": 2
          }
        ],
        "rol": null,
        "empresa": null
      }
    }
    //,
    return this.http.get(environment.wsUrl + `repse/usuario/datosUsuario`, {headers: headers}).pipe(
      map((resp: any) => {
        if (resp?.data?.group[0] == this.gpoAdmin && resp?.data?.empresa != null && resp?.data?.rol == 'admin') {
          //resp.data.rol = 'user';
          //resp.data.group[0] =  this.gpoProveedor;
          sessionStorage.setItem('---', new Date().toISOString());
        }
        sessionStorage.setItem('--- ', new Date().toISOString());

        //TODO: Revisra por que llega null
        //Validar si tienen acceso a repse
        // if (resp?.data?.sistema !== 'repse') {
        //   this.notif.snackbarError('No tiene acceso a este proyecto, favor de contactar al administrador', 'Acceso');
        //   throw new Error('Acceso denegado: No tiene acceso al sistema repse');
        // }
        console.log('resp------------------------------------------------------------------------', resp);
        const UserToServe: Usuario = {
          idUser: resp.data.idUser,
          apellidoMaterno: resp.data.apellidoMaterno,
          apellidoPaterno: resp.data.apellidoPaterno,
          bloqueado: resp.data.bloqueado,
          email: resp.data.email,
          fechaCreacion: resp.data.fechaCreacion,
          loginName: resp.data.loginName,
          nombre: resp.data.nombre,
          group: resp.data.group,
          catExpedientes: resp.data.catExpedientes,
          menu: resp.data.menu,
          modulo: resp.data.modulo,
          idEmpresa: resp.data.idEmpresa
        }
        const EmpresaToServe: Empresa = {
          empresa: resp.data.empresa,
          idEmpresa: resp.data.idEmpresa
        };
        // Carga Redux Usuario
        // this.store.dispatch(cargarUsuario(UserToServe));
        // Carga Redux Empresa
        //  this.store.dispatch(cargarEmpresa(EmpresaToServe));
        // Se quitaron para remplezarlo por Redux
        // sessionStorage.setItem('empresa', resp.data.empresa);
        // sessionStorage.setItem('loginName', resp.data.loginName);
        // sessionStorage.setItem('rol', resp.data.rol);

        if (resp.data.rol == 'user') {
          let mensajeBitacora = "El usuario " + resp.data.loginName + " de la empresa " + resp.data.empresa + " ha ";
          let mensajeB64 = btoa(mensajeBitacora);
          // Remplazar por Redux
          // sessionStorage.setItem('btoa', mensajeB64);

        } else {
          let mensajeBitacora = "El usuario " + resp.data.loginName + " ha ";
          let mensajeB64 = btoa(mensajeBitacora);
          // Remplazar por Redux
          // sessionStorage.setItem('btoa', mensajeB64);
        }


        // this.repse.obtenerEmpresas().subscribe((respEmpresa: any) => {
        this.repse.obtenerEmpresas().subscribe((respEmpresa: any) => {
          let empresa = respEmpresa.data.find(empresa => empresa.nombre == resp.data.empresa);

          //console.log('empresa', empresa);
          if (empresa == undefined) {
            empresa = {};
            empresa.id = 0;
          }

          // console.log('empresa===========', empresa);
          if (empresa.id != 0) {
            // Remplzar Redux
            // sessionStorage.setItem('idEmpresa', empresa.id);
            // sessionStorage.setItem('path1EmpresaRFC', empresa.rfc);
          }


          this.currentUser$.set = {
            empresa: resp.data.empresa,
            rolName: resp.data.rol,
            isAdmin: resp.data.rol === 'admin' ? true : false,
            empresaId: empresa.id,
            empresaRFC: empresa.rfc

          };

          // if(resp.data.loginName == 'ies.administrador'){
          //   this.currentUser$.set = {
          //     empresa: '',
          //     rolName: 'admin',
          //     isAdmin: true,
          //     empresaId: 0,
          //     empresaRFC: ''

          //   };
          // }

          //console.log('currentUser$', this.currentUser$);

        });

        if (resp.data.rol == 'admin') {
          resp.data.menu = dataUserFake.data.menu;
          resp.data.catExpedientes = dataUserFake.data.catExpedientes;
          //resp.data.modulo = dataUserFake.data.modulo;
        } else {
          resp.data.menu = menuUser;
          resp.data.catExpedientes = dataUserFake.data.catExpedientes;
        }

        //TODO: Quitar esto solo es fake en lo que se arregla
        // if(resp.data.loginName == 'ies.administrador'){
        //   resp.data.menu = dataUserFake.data.menu;
        //   resp.data.catExpedientes = dataUserFake.data.catExpedientes;
        //   resp.data.rol = 'admin';
        // }else {
        //   resp.data.menu = menuUser;
        //   resp.data.catExpedientes = dataUserFake.data.catExpedientes;
        // }

        return resp;
      })
    );
  }


  cerrarSesion(error?: boolean) {
    localStorage.removeItem('IES-AC-TK');
    localStorage.removeItem('IES-AC-RTK');
    if (error) sessionStorage.setItem('adios', 'salir');
    localStorage.clear();
    this.store.dispatch(resetDatosUsuarioAcc());
    this.store.dispatch(borrarEmpresa());
    sessionStorage.clear();
    this.router.navigate(['login']);
  }


}
